import React from 'react';
import dayjs from 'dayjs';
import store from '../../shared/store';
import Request from '../../shared/request';

class VasCards extends React.Component {
  state = {
    deviceUsed: 0,
    clientBtn: '扩增设备',
    clientLink: '/dashboard/vas',
    bandwidthBtn: '增加到 100 M',
    bandwidthLink: '/dashboard/vas?planId=bandwidth_100',
  };

  goBind = () => {
    this.props.history.push('/dashboard/bind');
  };

  async componentDidMount() {
    const devices = await Request.call('getDevices');
    this.setState({ deviceUsed: devices.length });
  }

  render() {
    return (
      <div className="vas-section">

        <div className="vas-card">
          <div className="content">
            <div className="icon">
              <i className="fad fa-link" />
            </div>
            <div className="middle">
              <div className="title">已绑定设备</div>
              <div className="value bind" onClick={() => this.goBind()}>
                <span>
                  {this.state.deviceUsed > store.user.clients
                    ? store.user.clients
                    : this.state.deviceUsed}
                </span>
                <small>/ {store.user.clients}</small>
              </div>
            </div>
            <div className="right">
              {this.state.clientBtn ? (
                <div
                  className="btn-vas"
                  onClick={() =>
                    this.props.history.push(this.state.clientLink)
                  }>
                  {this.state.clientBtn}
                </div>
              ) : (
                  ''
                )}

              {store.user.extraClientsExpiredAt &&
                store.user.extraClientsExpiredAt < store.user.planExpiredAt ? (
                  <div className="vas-end-date">
                    <span>到期时间:</span>
                    <span>
                      {dayjs(store.user.extraClientsExpiredAt).format(
                        'YYYY.MM.DD',
                      )}
                    </span>
                  </div>
                ) : (
                  ''
                )}
            </div>
          </div>
          <div className="bottom">
            <div
              className="left"
              onClick={() =>
                this.props.history.push(
                  `${!this.state.clientLink
                    ? '/dashboard/vas'
                    : this.state.clientLink
                  }`,
                )
              }>
              查看设备扩增套餐 <i className="ri-arrow-right-s-line" />
            </div>
            <div className="btn-bind" onClick={() => this.goBind()}>
              <i className="ri-links-line" />
              已绑定设备
            </div>
          </div>
        </div>


        {/* <div className="vas-card">
          <div className="content">
            <div className="icon">
              <i className="ri-database-line" />
            </div>
            <div className="middle">
              <div className="title">影音线路带宽</div>
              <div className="value">
                <span>{store.user.bandwidth}</span> <small>Mb</small>{' '}
              </div>
            </div>
            <div className="right">
              {this.state.bandwidthBtn ? (
                <div
                  className="btn-vas"
                  onClick={() =>
                    this.props.history.push(this.state.bandwidthLink)
                  }>
                  {this.state.bandwidthBtn}
                </div>
              ) : (
                  ''
                )}

              {store.user.bandwidthExpiredAt &&
                store.user.bandwidthExpiredAt < store.user.planExpiredAt ? (
                  <div className="vas-end-date">
                    <span>到期时间:</span>
                    <span>
                      {dayjs(store.user.bandwidthExpiredAt).format('YYYY.MM.DD')}
                    </span>
                  </div>
                ) : (
                  ''
                )}
            </div>
          </div>
          <div className="bottom">
            <div
              className="left"
              onClick={() =>
                this.props.history.push('/dashboard/vas?planId=bandwidth_100')
              }>
              查看带宽扩增套餐 <i className="ri-arrow-right-s-line" />
            </div>
          </div>
        </div> */}


        <div className="more-rights vas-vip">
          <div className="bind-tips">
            <span>免费用户只支持绑定 1 台设备</span>
            <a className="btn-unbind" href="/dashboard/bind">
              解绑设备
            </a>
          </div>
          <div className="title">标准会员权益</div>
          <div className="rights-item">
            <div className="items">
              <i class="fad fa-globe-americas"></i>
              <span>音视频专线</span>
            </div>
            <div className="items">
              <i class="fad fa-computer-speaker"></i>
              <span>3台设备同时在线</span>
            </div>
            <div className="items">
              <i class="fad fa-atom-alt"></i>
              <span>多模式切换</span>
            </div>
            <div className="items">
              <i class="fad fa-ad"></i>
              <span>应用内无广告</span>
            </div>
          </div>
        </div>

        <div className="more-rights vas-svip">
          <div className="title">高级会员权益</div>
          <div className="rights-item">
            <div className="items">
              <i class="fad fa-gamepad-alt"></i>
              <span>游戏专属专线</span>
            </div>
            <div className="items">
              <i class="fad fa-computer-speaker"></i>
              <span>3台设备同时在线</span>
            </div>
            <div className="items">
              <i class="fad fa-layer-group"></i>
              <span>多场景切换</span>
            </div>
            <div className="items">
              <i class="fad fa-ad"></i>
              <span>应用内无广告</span>
            </div>
          </div>
          {/* <a className="vas-btn-vip" href="/buy">
            购买高级会员
          </a> */}
        </div>
      </div>
    );
  }
}

export default VasCards;
